import { createSlice } from '@reduxjs/toolkit';
import {
  fetchOpsInitStateCreator,
  fetchPendingReducersCreator,
  fetchRejectedReducersCreator,
  fetchResetReducersCreator,
} from '../../utils/helpers/fetchReducerHelpers';
import { getCCEmailsConstants, updateCCEmailsConstants } from '../constants/ccEmailsConstants';
import { CC_EMAILS_DOMAIN_NAME } from '../constants/constants';

const opNames = ['getCCEmails', 'updateCCEmails'];
const actionNames = [getCCEmailsConstants, updateCCEmailsConstants];

const fetchOps = fetchOpsInitStateCreator(opNames);
const fetchPendingReducers = fetchPendingReducersCreator(actionNames, opNames, 'fetchOps');
const fetchRejectedReducers = fetchRejectedReducersCreator(actionNames, opNames, 'fetchOps');
const fetchResetReducers = fetchResetReducersCreator(actionNames, opNames, 'fetchOps');

const ccEmailsSlice = createSlice({
  name: CC_EMAILS_DOMAIN_NAME,
  initialState: {
    emails: [],
    fetchOps,
  },
  extraReducers: {
    ...fetchPendingReducers,
    ...fetchRejectedReducers,
    ...fetchResetReducers,
    [getCCEmailsConstants.fulfilled]: (state, { payload }) => {
      state.fetchOps.getCCEmails.status = 'succeeded';
      state.fetchOps.getCCEmails.error = null;
      state.emails = payload.emails;
    },
    [updateCCEmailsConstants.fulfilled]: (state, { payload }) => {
      state.fetchOps.updateCCEmails.status = 'succeeded';
      state.fetchOps.updateCCEmails.error = null;
      state.emails = payload.emails;
    },
  },
});

export default ccEmailsSlice.reducer;
